<app-top-navbar />
@if (!isMobile) {
  <mat-sidenav-container [autosize]="true" [hasBackdrop]="false">
    <mat-sidenav
      class="left-navigation-sidenav"
      [class.is-collapsed]="leftNavCollapsed$ | async"
      [fixedTopGap]="56"
      [mode]="'side'"
      [opened]="true"
      [position]="'start'"
      (transitionend)="syncLeftSidenavMargins($event.propertyName)"
      fixedInViewport
      role="navigation"
    >
      <app-left-sidenav />
    </mat-sidenav>
    <mat-sidenav [mode]="drawerMode$ | async" [opened]="drawerOpened$ | async" [position]="'end'">
      <app-right-sidenav />
    </mat-sidenav>
    <mat-sidenav-content role="main">
      <app-overlay-spinner />
      @if (!isIframe) {
        <div class="app-shell-content">
          <div class="app-shell-breadcrumb">
            <app-breadcrumb />
            @if (showHomeActionButton()) {
              <button (click)="onRaiseIssueEventButtonClick()" color="primary" mat-flat-button>Report event or raise issue</button>
            }
          </div>
          <router-outlet />
        </div>
      }
    </mat-sidenav-content>
  </mat-sidenav-container>
}
@if (isMobile) {
  <mat-sidenav-container>
    <mat-sidenav-content>
      <div class="justify-content-center align-items-center loading">
        <div class="SystemNotice">
          <img alt="Info" height="30" ngSrc="assets/images/rcsa/ic3-red.svg" width="30" /><br />
          <strong> Important: </strong> OneORM is not accessible on mobile devices, please use Swiss Re notebook instead
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
}
